import { render, staticRenderFns } from "./CustomPermissionDetailForm.vue?vue&type=template&id=8dbe7ab0"
import script from "./CustomPermissionDetailForm.vue?vue&type=script&lang=js"
export * from "./CustomPermissionDetailForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports